import styled, { keyframes } from "styled-components";

// Animações básicas
const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  align-items: stretch;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
  min-height: 0;
  max-height: 100%;
  background-size: 400% 400%;
  font-family: "Inter", "Helvetica Neue", sans-serif;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  animation: ${fadeIn} 0.6s ease-out;

  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: var(--accent, #6b8f71);
    border-radius: 10px;
  }

  @media screen and (max-width: 768px) {
    width: 100%;
  }
`;

export const ContentWrapper = styled.div`
  position: relative;
  z-index: 1;
  width: 100%;
  flex: 0 0 auto;
  height: auto;
  min-height: min-content;
  max-width: none;
  padding: 1.25rem 1.25rem 2rem;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  margin: 0;
  box-sizing: border-box;
  overflow: visible;

  @media screen and (max-width: 768px) {
    padding: 0.75rem 0.5rem 1.5rem;
  }
`;

export const GraphsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* 2 colunas */
  gap: 15px; /* Espaçamento entre os gráficos */
  margin-bottom: 30px; /* Espaçamento entre fileiras */
  width: 100%;
  animation: ${fadeInUp} 0.8s ease-out;
  animation-delay: ${props => props.delay || '0.2s'};
  animation-fill-mode: both;

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 10px;
  }
`;


export const GraphWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  /* Garantir que o gráfico se ajuste ao espaço disponível */
  width: 100%;
  //height: 80%;
`;

export const MotionDiv = styled.div`
  animation: ${fadeInUp} 0.8s ease-out;
  animation-delay: ${props => props.delay || '0s'};
  animation-fill-mode: both;
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-2px);
  }
`;

export const SectionTitle = styled.h2`
  font-size: 2.5rem;
  font-weight: 700;
  background: linear-gradient(135deg, var(--accent-secondary) 0%, var(--accent) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin: 0 0 2rem 0;
  text-shadow: 0 4px 20px var(--accent-secondary-soft);
  text-align: center;
  animation: ${fadeInUp} 0.6s ease-out;
  animation-delay: 0.1s;
  animation-fill-mode: both;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;



//
export const Button = styled.button`
  --background-color: var(--accent-secondary);
  background-color: var(--accent);
  border-radius: 100px;
  box-shadow: var(--shadow-sm);
  color: var(--text-on-accent);
  cursor: pointer;
  display: inline-block;
  font-family: CerebriSans-Regular,-apple-system,system-ui,Roboto,sans-serif;
  padding: 3px 5px;
  text-align: center;
  text-decoration: none;
  transition: all 250ms;
  border: 0;
  font-size: 11px;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  margin-right: 65px;
  width: 50px;
  height: 30px;

  :hover {
    box-shadow: var(--shadow-md);
    transform: scale(1.02) ;
  }

  @media screen and (max-width: 768px) {
    font-size: 10px;
  }
`;

export const Input = styled.input`
  padding: 10px;
  margin-bottom: 20px;
  border: 2px solid var(--border-default);
  border-radius: 4px;
  padding: 8px;
  font-size: 16px;
  outline: none;
  width: 250px;
  background-color: var(--input-bg);
  color: var(--text-primary);

  &::placeholder {
    color: var(--input-placeholder);
  }

  &:focus {
    border-color: var(--info);
    background-color: var(--input-bg-focus);
  }
`;